
import { cloneDeep, omit } from 'lodash';
import { PropType, computed, defineComponent, onMounted, ref } from 'vue';

import { countAppliedFilters } from 'SharedDir/common/composables/useFilters';

import { useLoadingSsr } from 'PortalDir/common/composables/useLoadingSsr';
import { Filters } from 'PortalDir/modules/Services/composables/usePublicServicesFilters';

export default defineComponent({
  name: 'Filters',
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    defaultFilters: {
      type: Object,
      required: true,
      default: () => {},
    },
    notCountableProperties: {
      type: Array as PropType<string[]>,
      required: false,
      default: () => ['name'],
    },
  },
  emits: ['apply-filter', 'update:modelValue', 'clear'],
  setup(props, { emit }) {
    const { isLoading, showLoading } = useLoadingSsr();
    const show = ref<boolean>(false);
    const innerValue = ref({});

    const filters = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    const appliedFiltersCount = computed(() => {
      // console.log(filters.value, props.defaultFilters);
      // console.log(countAppliedFilters(filters.value, props.defaultFilters));
      return countAppliedFilters(
        omit(filters.value, props.notCountableProperties),
        props.defaultFilters
      ).length;
    });

    function reset() {
      filters.value = cloneDeep(props.defaultFilters);
      emit('apply-filter', filters.value);
    }

    function open() {
      show.value = true;
    }

    function close() {
      show.value = false;
    }

    onMounted(async () => {
      isLoading.value = false;
    });

    return {
      emit,
      show,
      reset,
      open,
      close,
      appliedFiltersCount,
      innerValue,
      filters,
      isLoading,
    };
  },
});
